import { render, staticRenderFns } from "./ShopTable.vue?vue&type=template&id=4dad84c1&scoped=true&"
import script from "./ShopTable.vue?vue&type=script&lang=js&"
export * from "./ShopTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dad84c1",
  null
  
)

export default component.exports